import React from 'react';
import { useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';

import { ErrorMessage } from '../error-message.component';

export function HttpError(): JSX.Element {
  const location = useLocation();
  const state: {
    statusCode: number | string;
    message: string;
  } = location.state;

  return (
    <ErrorMessage>
      <Typography>ERROR: {state.statusCode}</Typography>
      <Typography>{state.message}</Typography>
    </ErrorMessage>
  );
}
